module.exports = __webpack_public_path__ + "media/images/excel-5d6d0dd3c84133556340e532db7210a0.png";